// Product Images
export const PRODUCT_IMAGES = {
  main: 'https://cdn.magicpatterns.com/uploads/obbeETWSQjva61Ftz39ECz/Tomo_1.png',
  tomo2:
    'https://cdn.magicpatterns.com/uploads/6LHQnB1tBqBFQKroD4Pq83/Tomo_2.png',
  tomo3:
    'https://cdn.magicpatterns.com/uploads/xhwcmu4qxUDgTeunonhdQh/Tomo_3.png',
  tomo4:
    'https://cdn.magicpatterns.com/uploads/dt4dsNyApUTT63reGXJbQo/Tomo_4.png',
  tomo5:
    'https://cdn.magicpatterns.com/uploads/kPZwhkyyjigYpSXrov9EBw/Tomo_5.png',
  bonus1:
    'https://cdn.magicpatterns.com/uploads/8DMBkW7aegWcXi7EfarVC6/bono_1.png',
  bonus2:
    'https://cdn.magicpatterns.com/uploads/qGNvQMWRJWNWuJhVWia1Ak/bono_2.png',
  bonus3:
    'https://cdn.magicpatterns.com/uploads/itUKwsWtqc7rdwPEjAMVKa/bono_3.png',
  bonus4:
    'https://cdn.magicpatterns.com/uploads/hRZ2RUFuUBBW6zoPZB7ZSf/bono_4.png',
}

// Payment & Tracking
export const PAYMENT_LINK =
  'https://pay.hotmart.com/B105640202S?checkoutMode=10'
export const META_PIXEL_ID = '26913593174942930'

// Pricing
export const PRICING = {
  originalPrice: '89,99 €',
  salePrice: '17,99 €',
  totalValue: '155,95 €',
  savingsPercent: '80%',
}

// Main Resources
export const MAIN_RESOURCES = [
  {
    title: '100 Posizioni Yoga Illustrate per Bambini',
    description:
      'Guida visiva completa con asana adattate per età 3-12 anni, con istruzioni passo-passo e varianti per ogni livello.',
  },
  {
    title: "50 Lezioni Pronte all'Uso (3-12 anni)",
    description:
      "Piani di lezione completi divisi per fascia d'età, durata e obiettivo educativo. Apri, stampa e insegna.",
  },
  {
    title: 'Yoga-Storie e Avventure Guidate',
    description:
      '30 racconti immaginari che trasformano ogni lezione in un viaggio magico, con asana integrate nella narrazione.',
  },
  {
    title: 'Manuale di Respirazione e Mindfulness per Bambini',
    description:
      'Tecniche di respirazione, giochi di consapevolezza e meditazioni guidate adattate al linguaggio dei più piccoli.',
  },
  {
    title: 'Giochi Yoga e Attività di Gruppo',
    description:
      "80+ giochi yoga, dinamiche di gruppo e attività in coppia per mantenere alta l'attenzione e divertire la classe.",
  },
]

// Bonuses
export const BONUSES = [
  {
    title: '30 Storie di Yoga per Bambini',
    description:
      'Avventure guidate con posizioni yoga integrate nella narrazione. Ogni storia trasforma la lezione in un viaggio magico.',
    value: '19,99 €',
    image: PRODUCT_IMAGES.bonus1,
  },
  {
    title: '50 Carte di Respirazione per Bambini',
    description:
      'Set stampabile di esercizi di respirazione con illustrazioni colorate, perfetto per guidare momenti di calma e consapevolezza.',
    value: '14,99 €',
    image: PRODUCT_IMAGES.bonus2,
  },
  {
    title: '21 Routine di Yoga per Bambini',
    description:
      'Programma completo di 21 giorni con posizioni e sequenze progressive, pronto da seguire giorno per giorno.',
    value: '17,99 €',
    image: PRODUCT_IMAGES.bonus3,
  },
  {
    title: 'Attività Creative per Mindfulness',
    description:
      'Disegnare il respiro, colorare le emozioni, il mandala della calma e il barattolo della gratitudine. Attività pratiche per sviluppare la consapevolezza.',
    value: '12,99 €',
    image: PRODUCT_IMAGES.bonus4,
  },
]

// Pain Points
export const PAIN_POINTS = [
  'Passi ore a cercare idee online per le tue lezioni e non trovi mai materiale davvero pensato per i bambini.',
  'I bambini si distraggono, si annoiano o non riescono a concentrarsi durante le sessioni che proponi.',
  'Non sai come adattare le posizioni yoga alle diverse età senza renderle pericolose o troppo complicate.',
  'Senti di ripetere sempre le stesse attività e non hai abbastanza varietà per mantenere viva la curiosità della classe.',
]

// Benefits
export const BENEFITS = [
  'Risparmia ore di preparazione: tutte le lezioni sono già pronte, organizzate per età e obiettivo.',
  "Cattura l'attenzione dei bambini con storie, giochi e attività che rendono lo yoga irresistibile.",
  "Insegna in totale sicurezza grazie a posizioni illustrate e adattate ad ogni fascia d'età.",
  'Diversifica ogni sessione con oltre 80 giochi, 30 storie guidate e 100 posizioni illustrate.',
  'Cresci come insegnante con un sistema strutturato che funziona dalla prima lezione.',
]

// Testimonials
export const TESTIMONIALS = [
  {
    name: 'Giulia Marchetti',
    age: 34,
    city: 'Milano, Italia',
    review:
      'Insegno yoga ai bambini da tre anni e questo pack ha cambiato completamente le mie lezioni. I bambini sono entusiasti, le storie li conquistano subito e finalmente ho una struttura chiara da seguire. Lo consiglio a tutti i miei colleghi.',
  },
  {
    name: 'Francesca Russo',
    age: 41,
    city: 'Roma, Italia',
    review:
      'Sono maestra di scuola primaria e cercavo da tempo qualcosa di concreto per portare lo yoga in classe. Le schede stampabili e le lezioni pronte sono un tesoro. I miei alunni adorano il momento yoga della settimana.',
  },
  {
    name: 'Alessandra Bianchi',
    age: 29,
    city: 'Torino, Italia',
    review:
      'Ho iniziato come istruttrice da poco e avevo paura di non sapere come gestire i gruppi di bambini. Con questo materiale mi sento preparata e sicura. Le yoga-storie sono geniali!',
  },
  {
    name: 'Marco Esposito',
    age: 38,
    city: 'Napoli, Italia',
    review:
      "Lavoro in un centro educativo e cercavo risorse di qualità per i nostri laboratori. Il calendario annuale è perfetto per programmare tutto l'anno. Vale ogni centesimo.",
  },
  {
    name: 'Chiara Romano',
    age: 32,
    city: 'Bologna, Italia',
    review:
      'Sono mamma e insegnante di yoga. Uso questo pack sia con i miei figli a casa sia con i bambini delle mie classi. Le musiche rilassanti sono bellissime e i giochi funzionano davvero.',
  },
]

// FAQ
export const FAQ = [
  {
    question:
      "Devo avere esperienza nell'insegnare yoga ai bambini per usare questo pack?",
    answer:
      'Assolutamente no. Il Mega-Pack è pensato sia per insegnanti esperti che per chi sta iniziando. Tutte le lezioni includono istruzioni passo-passo, varianti per età e suggerimenti pratici per gestire la classe.',
  },
  {
    question: "A quale fascia d'età è adatto il materiale?",
    answer:
      "Le risorse coprono i bambini dai 3 ai 12 anni. Ogni lezione è chiaramente segnalata per fascia d'età, così puoi scegliere subito ciò che serve.",
  },
  {
    question: "Come riceverò il pack dopo l'acquisto?",
    answer:
      "Riceverai immediatamente un'email con l'accesso a tutti i materiali in formato digitale (PDF, MP3 e schede stampabili). Potrai scaricare tutto sul tuo dispositivo e usarlo per sempre.",
  },
  {
    question: 'Posso usare il materiale per le mie lezioni a pagamento?',
    answer:
      "Sì, hai una licenza d'uso personale completa. Puoi utilizzare le risorse nelle tue classi, laboratori, scuole o sessioni private senza alcuna limitazione.",
  },
  {
    question: 'Cosa succede se non sono soddisfatto?',
    answer:
      'Hai 45 giorni di garanzia totale. Se per qualsiasi motivo il pack non ti convince, ti rimborsiamo il 100% senza fare domande. Nessun rischio per te.',
  },
]

// Purchase Popup Names
export const POPUP_NAMES = [
  { name: 'Sofia M.', city: 'Milano' },
  { name: 'Lorenzo B.', city: 'Roma' },
  { name: 'Martina G.', city: 'Firenze' },
  { name: 'Davide R.', city: 'Torino' },
  { name: 'Federica L.', city: 'Napoli' },
  { name: 'Alessia C.', city: 'Bologna' },
  { name: 'Matteo F.', city: 'Verona' },
  { name: 'Valentina P.', city: 'Genova' },
  { name: 'Riccardo S.', city: 'Palermo' },
  { name: 'Elena D.', city: 'Bari' },
  { name: 'Tommaso N.', city: 'Catania' },
  { name: 'Beatrice V.', city: 'Padova' },
]
